import React from 'react';
import PropTypes from 'prop-types';
import Widgets from '../../components/iframeWidget';
import WithWrapper from '../../components/iframeWidget/WithWrapper';
import NotFound from '../not-found/NotFound';
import { getQueryParams, modifyNestedObjects } from '../../utils/common';
import { ETIMES_VIDEO_API_KEY, TOI_VIDEO_API_KEY } from '../../constants';

const notFoundTitle = 'Page not found';

/**
 * Component to render widget inside iframe
 * @param {*} url: Window browser url
 */
const RenderIframeWidget = ({
  url,
  widget,
  isWapView,
  showelectioniframe,
  tabs,
}) => {
  let widgetDetails = Widgets[(widget || '').toUpperCase()];
  if (
    widget.toUpperCase() === 'VIDEOPLAYER' &&
    parseInt(getQueryParams('etimes', { href: url }), 10) === 1
  ) {
    const playerSubsec = getQueryParams('playersubsec', { href: url });
    const msid = getQueryParams('msid', { href: url });
    const playlistUrl = `https://m.timesofindia.com/etvidepostroll_v7/${playerSubsec}.cms?feedtype=json&dontshow=${msid}&callback=cached`;
    widgetDetails = modifyNestedObjects(
      widgetDetails,
      'apiKey',
      TOI_VIDEO_API_KEY,
      ETIMES_VIDEO_API_KEY,
    );
    widgetDetails = modifyNestedObjects(
      widgetDetails,
      'playlistUrl',
      '',
      playlistUrl,
    );
  }

  if (
    (!showelectioniframe && widget.toUpperCase() === 'ELECTIONWDT') ||
    !widgetDetails
  ) {
    return <NotFound title={notFoundTitle} />;
  }
  const EnhancedWidget = WithWrapper({
    widgetName: widget,
    url,
    isWapView,
    tabs,
    ...widgetDetails,
  });
  return <EnhancedWidget />;
};

RenderIframeWidget.propTypes = {
  url: PropTypes.string.isRequired,
  widget: PropTypes.string.isRequired,
  showelectioniframe: PropTypes.bool,
};

RenderIframeWidget.defaultProps = {
  showelectioniframe: false,
};

export default RenderIframeWidget;
